"use client"

import { FeedbackWidget } from "@forestsync/ui"
import { useTranslations } from "next-intl"
import { submitFeedback } from "@/actions/feedback"

export function FeedbackButton({ variant = "icon" }: { variant?: "icon" | "menuItem" }) {
  const t = useTranslations("feedback")

  return (
    <FeedbackWidget
      variant={variant}
      onSubmit={submitFeedback}
      labels={{
        trigger: t("trigger"),
        title: t("title"),
        messageLabel: t("messageLabel"),
        messagePlaceholder: t("messagePlaceholder"),
        emailLabel: t("emailLabel"),
        emailPlaceholder: t("emailPlaceholder"),
        submit: t("submit"),
        success: t("success"),
        error: t("error"),
        close: t("close"),
      }}
    />
  )
}
